import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { useGlobalStore } from '../../../../store'
import { MuiTextField, MuiSelect, AccordionWithArrow, MessageReactQuery } from '../../../../components'
import forumService from '../../../../services/forum.service'
import { useReactQuery } from '../../../../hooks/useReactQuery'

const UserMarketResearchQuestionsGlobal = ({ data, mode, onChange, expanded }) => {
  const { company } = useGlobalStore()
  const [formSectionData, setFormSectionData] = useState({
    globalQuestion1: data?.GlobalQuestion1 || null,
    globalQuestion2: data?.GlobalQuestion2 || null
  })

  const [formSelectData, setFormSelectData] = useState({
    globalQuestion2: []
  })

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formSectionData,
      [key]: value
    }
    setFormSectionData(obj)
    onChange(obj)
  }

  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: ['GlobalQuestion1'],
      urlFunc: forumService.getGlobalQuestion1Api,
      payload: { organizationId: company?.OrganizationId }
    },
    useReactQueryObject: { cacheTime: 10000 }
  }
  const { data: data1, isLoading: isLoading1, isSuccess: isSuccess1, isError: isError1, error: error1 } = useReactQuery(useReactQueryObject1)

  // const onload = async () => {
  //   const payload = { organizationId: company?.OrganizationId }
  //   const globalQuestion1Api = await forumService.getGlobalQuestion1Api(payload)
  //   const globalQuestion1Array = (globalQuestion1Api.length > 0) ? globalQuestion1Api.map(d => ({ label: d, value: d, selected: d === data.GlobalQuestion1 })) : []
  //   setFormSelectData({ ...formSelectData, globalQuestion1: [{ label: '', value: '-1', selected: data.GlobalQuestion1 === '-1' }, ...globalQuestion1Array] })
  // }

  const hasDataAndNotDisabled = (value) => {
    if (mode) { return (value?.length > 0) && mode }
    return true
  }

  // useEffect(() => {
  //   onload()
  // }, [])

  const onSuccess1Func = (resp) => {
    const globalQuestion1Array = (resp.length > 0) ? resp.map(d => ({ label: d, value: d, selected: d === data.GlobalQuestion1 })) : []
    setFormSelectData({ ...formSelectData, globalQuestion1: [{ label: '', value: '-1', selected: data.GlobalQuestion1 === '-1' }, ...globalQuestion1Array] })
  }
  useEffect(() => {
    if (isSuccess1 && data1?.length) onSuccess1Func(data1)
  }, [isSuccess1, data1])

  return (
    <AccordionWithArrow title='User Market Research Questions (GLOBAL)' expanded={expanded} accordionstyle='fieldset' showOverlay={mode}>
    <MessageReactQuery
      isLoading={isLoading1}
      isSuccess={isSuccess1}
      data={data1}
      isError={isError1}
      error={error1}
    />
      <Grid container spacing={2}>
        {hasDataAndNotDisabled(formSectionData?.globalQuestion1) && <Grid item xs={6}>
          <MuiSelect
            data={formSelectData.globalQuestion1}
            name='globalQuestion1'
            // label='Global Question 1'
            placeholder='Global Question 1'
            onChange={(e) => onChangeHandler('globalQuestion1', e.target.value)}
            variant='standard'
            value={formSectionData?.globalQuestion1}
            disabled={mode}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.globalQuestion2) && <Grid item xs={6}>
          <MuiTextField
            name='globalQuestion2'
            // label='Global Question 2'
            placeholder='Global Question 2'
            onChange={(e) => onChangeHandler('globalQuestion2', e.target.value)}
            variant='standard'
            value={formSectionData?.globalQuestion2 || ''}
            disabled={mode}
          />
        </Grid>}
      </Grid>
    </AccordionWithArrow>
  )
}

UserMarketResearchQuestionsGlobal.propTypes = {
  data: PropTypes.object,
  mode: PropTypes.bool,
  onChange: PropTypes.func,
  expanded: PropTypes.bool
}

export default UserMarketResearchQuestionsGlobal
